var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustrationPageLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 246,
    viewBox: "0 0 288 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 237.8C206.485 237.8 257.143 187.417 257.143 125.05C257.143 62.6824 206.262 12.3 144 12.3C81.5147 12.3 30.8572 62.6824 30.8572 125.05C30.8572 187.417 81.5147 237.8 144 237.8Z",
    fill: "#F4F6FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5852_14892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.373 76.1624L216 207.309C216 211.788 212.339 215.25 207.864 215.25H80.1356C75.661 215.25 72 211.584 72 207.309V38.6921C72 34.2119 75.661 30.75 80.1356 30.75H172.679L214.373 76.1624Z",
    fill: "url(#paint0_linear_5852_14892)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.238 188.981H109.22C108.203 188.981 107.39 187.963 107.39 186.741C107.39 185.519 108.203 184.501 109.22 184.501H134.238C135.254 184.501 136.068 185.519 136.068 186.741C136.068 188.166 135.254 188.981 134.238 188.981Z",
    fill: "#D5DDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.78 58.2423H93.5594C92.1356 58.2423 90.9153 57.0204 90.9153 55.5949C90.9153 54.1694 92.1356 52.9475 93.5594 52.9475H154.78C156.204 52.9475 157.424 54.1694 157.424 55.5949C157.424 57.0204 156.204 58.2423 154.78 58.2423Z",
    fill: "#D5DDEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.153 72.9044H93.5594C92.1356 72.9044 90.9153 71.6825 90.9153 70.257C90.9153 68.8315 92.1356 67.6096 93.5594 67.6096H116.949C118.373 67.6096 119.593 68.8315 119.593 70.257C119.593 71.6825 118.373 72.9044 117.153 72.9044Z",
    fill: "#D5DDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.679 30.75V66.9985C172.679 72.0896 177.153 76.1625 182.238 76.1625H214.373",
    fill: "#D5DDEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.194 153.74H125.625H117.847H94.324C93.3755 153.74 92.4271 154.692 92.4271 156.025C92.4271 157.167 93.1858 158.309 94.324 158.309H117.847H125.625H196.194C197.142 158.309 198.091 157.357 198.091 156.025C197.901 154.692 197.142 153.74 196.194 153.74Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.004 137.181H169.825H160.909H94.324C93.3755 137.181 92.4271 138.133 92.4271 139.465C92.4271 140.607 93.1858 141.749 94.324 141.749H160.909H169.825H196.004C196.952 141.749 197.901 140.797 197.901 139.465C197.711 138.133 196.952 137.181 196.004 137.181Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.573 120.431H189.744H182.915H94.324C93.3755 120.431 92.4271 121.383 92.4271 122.715C92.4271 123.857 93.1858 124.999 94.324 124.999H182.915H190.502H196.383C197.332 124.999 198.28 124.047 198.28 122.715C198.47 121.573 197.521 120.431 196.573 120.431Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.332 103.871H175.137H169.635H94.324C93.3755 103.871 92.4271 104.823 92.4271 106.155C92.4271 107.297 93.1858 108.439 94.324 108.439H169.635H175.137H197.142C198.47 108.439 199.229 107.488 199.229 106.155C199.229 105.013 198.47 103.871 197.332 103.871Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6742 217.96H67.5269C64.3157 217.96 61.722 215.213 61.722 211.813V169.048C61.722 157.147 70.8616 147.6 81.9771 147.6C93.0925 147.6 102.232 157.278 102.232 169.048V211.944C102.355 215.213 99.7619 217.96 96.6742 217.96ZM73.3317 205.797H90.8695V169.048C90.8695 163.948 86.9173 159.763 82.1006 159.763C77.2839 159.763 73.3317 163.948 73.3317 169.048V205.797Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.654 229.6H55.9173C52.3356 229.6 49.3715 226.46 49.3715 222.668V185.657C49.3715 181.864 52.3356 178.726 55.9173 178.726H108.654C112.236 178.726 115.2 181.864 115.2 185.657V222.668C115.2 226.46 112.236 229.6 108.654 229.6Z",
    fill: "#C2C8D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8933 198.473C88.8933 201.22 87.4113 203.574 85.3117 204.751V212.336C85.3117 214.167 83.9531 215.606 82.2239 215.606C80.495 215.606 79.1363 214.167 79.1363 212.336V204.751C77.0367 203.574 75.5547 201.22 75.5547 198.473C75.5547 194.55 78.5189 191.411 82.2239 191.411C85.9291 191.411 88.8933 194.55 88.8933 198.473Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5852_14892",
    x: 52,
    y: 12.75,
    width: 184,
    height: 224.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5852_14892"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5852_14892",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5852_14892",
    x1: 143.954,
    y1: 26.4824,
    x2: 143.954,
    y2: 217.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustrationPageLock);
export default ForwardRef;